module.exports = __webpack_public_path__ + "img/TH.99b073b1.svg";